export default {
  cfgChanged: 'Configuration changed',
  dpiChanged: 'DPI switched',
  rtChanged: 'RT switched',
}
